<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title">
            Username and Password
        </div>
        <div class="account_section_box">
            <div class="row">
                <div id="AccountEmailAddress" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.AccountEmailAddress">
                        <label>Email Address*</label>
                        <input v-bind:class="{ error_field: AccountValidationResult.AccountEmailAddress }" v-model="Account.EmailAddress" type="email" class="form-control" v-on:blur="ValidateEmail()" oninput="this.value = this.value.toLowerCase()">
                        <p class="error-message" v-if="AccountValidationResult.AccountEmailAddress">{{AccountValidationResult.AccountEmailAddress}}</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.AccountEmailAddressConfirm">
                        <label>Confirm Email Address*</label>
                        <input v-bind:class="{ error_field: AccountValidationResult.AccountEmailAddressConfirm }" v-model="Account.EmailAddressConfirm" type="email" class="form-control" v-on:blur="ValidateConfirmEmail()" oninput="this.value = this.value.toLowerCase()">
                        <p class="error-message" v-if="AccountValidationResult.AccountEmailAddressConfirm">{{AccountValidationResult.AccountEmailAddressConfirm}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                    <p>This email address will be used to log in to your account as well as receive general program and order communications.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.AccountPassword">
                        <label>Password*</label>
                        <input v-on:keyup="CheckPasswordDigits(); CheckMatchPassword()" 
                            v-bind:class="{ error_field:  AccountValidationResult.AccountPassword, error_field2: hasPasswordError }" 
                            v-model="Account.Password" type="password" class="form-control">
                        <p class="error-message" v-if="AccountValidationResult.AccountPassword">{{AccountValidationResult.AccountPassword}}</p>
                        <!-- REAL TIME VALIDATION -->
                        <p v-else-if="hasPasswordError && !AccountValidationResult.AccountPassword" class="error-message">{{hasPasswordErrorMessage}}</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.AccountPasswordConfirm">
                        <label>Confirm Password*</label>
                        <input v-on:keyup="CheckConfirmPasswordDigits(); CheckMatchPassword()" 
                            v-bind:class="{ error_field:  AccountValidationResult.AccountPasswordConfirm, error_field2: hasConfirmPasswordError }" 
                            v-model="Account.PasswordConfirm" type="password" class="form-control">
                        <p class="error-message" v-if="AccountValidationResult.AccountPasswordConfirm">{{AccountValidationResult.AccountPasswordConfirm}}</p>
                        <!-- REAL TIME VALIDATION -->
                        <p v-if="hasConfirmPasswordError && !AccountValidationResult.AccountPasswordConfirm" class="error-message">{{hasConfirmPasswordErrorMessage}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    var typingTimer;
    export default 
    {
        props: ['Account', 'AccountValidationResult', 'FormInputs'],
		data() {
            return {
                hasPasswordError: false,
                hasConfirmPasswordError: false,
                hasPasswordErrorMessage: '',
                hasConfirmPasswordErrorMessage: ''
            }
        },
        methods:
        {
            ValidateEmail(){
                // clearTimeout(typingTimer);
                // if (this.Account.EmailAddress)
                // {
                //     typingTimer = setTimeout(this.$emit("clicked"), 2000);
                // }
                this.$emit("clicked");
            },
            ValidateConfirmEmail(){
                this.$emit("confirm");
            },
            CheckPasswordDigits(){
                var tempAccountPassword = this.AccountValidationResult.AccountPassword;
                if(this.Account.Password){
                    if(this.Account.Password.length > 0){
                        this.AccountValidationResult.AccountPassword = null;
                        if(this.Account.Password.length < 6){
                            this.hasPasswordError = true;
                            this.hasPasswordErrorMessage = "Password must be at least 6 characters"
                        }
                        else {
                            this.hasPasswordError = false;
                            this.hasPasswordErrorMessage = "";
                        }
                    }
                }
                else{
                    // this.hasPasswordError = true;
                    // if(this.AccountValidationResult != []){
                    //     this.AccountValidationResult.AccountPassword = "This field is required";
                    // }
                }
            },
            CheckConfirmPasswordDigits(){
                var tempAccountPassword = this.AccountValidationResult.AccountPasswordConfirm;
                if(this.Account.PasswordConfirm){
                    if(this.Account.PasswordConfirm.length > 0){
                        this.AccountValidationResult.AccountPasswordConfirm = null;
                        if(this.Account.PasswordConfirm.length < 6){
                            this.hasConfirmPasswordError = true;
                            this.hasConfirmPasswordErrorMessage = "Password must be at least 6 characters";
                        }
                        else {
                            this.hasConfirmPasswordError = false;
                            this.hasConfirmPasswordErrorMessage = "";
                        }
                    }
                }
                else {
                    // this.hasConfirmPasswordError = true;
                    // if(this.AccountValidationResult != []){
                    //     this.AccountValidationResult.AccountPasswordConfirm = "This field is required";
                    // }
                }
            },
            CheckMatchPassword(){
                var tempAccountPassword = this.AccountValidationResult.AccountPassword;
                var tempAccountPasswordConfirm = this.AccountValidationResult.AccountPasswordConfirm;
                if(this.Account.Password && this.Account.PasswordConfirm){
                    if(this.Account.Password.length > 0 && this.Account.PasswordConfirm.length > 0){
                        this.AccountValidationResult.AccountPassword = null;
                        this.AccountValidationResult.AccountPasswordConfirm = null;
                        if(this.Account.Password == this.Account.PasswordConfirm){
                            this.hasPasswordError = false;
                            this.hasConfirmPasswordError = false;
                            this.hasConfirmPasswordErrorMessage = "";
                            this.CheckPasswordDigits();
                            this.CheckConfirmPasswordDigits();
                        }
                        else {
                            this.hasPasswordError = true;
                            this.hasConfirmPasswordError = true;
                            this.hasConfirmPasswordErrorMessage = "Password does not match";
                        }
                    }
                } 
                else {
                    // this.AccountValidationResult.AccountPassword = "This field is required";
                    // this.AccountValidationResult.AccountPasswordConfirm = "This field is required";
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// UsernameAndPassword.vue?5959e036